import { motion } from "framer-motion";

const BASE = "/api/media/wp/2025/01/";
const PARTNERS = [
  { file: "best-in.webp", alt: "Best in Mountain Tourism Awards" },
  { file: "Connections-Leaders-copy-1.webp", alt: "Connections Leader" },
  { file: "hra-icon.webp", alt: "Himalayan Rescue Association Nepal" },
  { file: "IGLTA_Member_Logo_HRZ_4color.webp", alt: "IGLTA Member" },
  { file: "IPD-LOGO.webp", alt: "Import Promotion Desk (IPD)" },
  { file: "nma-icon.webp", alt: "Nepal Mountaineering Association" },
  { file: "npl-icon.webp", alt: "Government of Nepal" },
  { file: "ntb-icon.webp", alt: "Nepal Tourism Board" },
  { file: "Ra-award-final-copy.webp", alt: "LUXlife Awards — Responsible Adventures" },
  { file: "Screenshot-2020-04-21-at-14.36.46.webp", alt: "Glamping.com" },
  { file: "taan-icon.webp", alt: "Trekking Agencies' Association of Nepal (TAAN)" },
  { file: "TravGanic-Silver-Certified-Square-copy.webp", alt: "TravGanic Sustainable Tour Operator — Silver Certification" },
  { file: "trip-advisor-2018.webp", alt: "Tripadvisor Certificate of Excellence 2018" },
  { file: "was-icon.webp", alt: "World Adventure Society" },
];

export default function PartnersStrip() {
  return (
    <section className="border-t border-sand-dark bg-[#FDFBF7]" data-testid="partners-strip">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <div className="text-center mb-10 sm:mb-14">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-terracotta mb-3">Recognised & trusted</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight text-ink">Our partnerships & nominations</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-x-6 gap-y-10 items-center">
          {PARTNERS.map((p, i) => (
            <motion.div key={p.file}
              initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: (i % 7) * 0.04 }}
              className="flex items-center justify-center" data-testid={`partner-${i}`}>
              <img src={`${BASE}${p.file}`} alt={p.alt} title={p.alt} loading="lazy"
                className="max-h-20 w-auto object-contain opacity-80 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
